// extracted by mini-css-extract-plugin
export default {"likeBtn":"YGW1HosMIfQg0tcn4wer","likeCounter":"E7LwE44sm65O5Ho3CP7j","liked":"lSP9i7GJTyGkcp4L0kBQ","like-text":"Ob6N9zaSAGJzjKRbFkTQ","likeText":"Ob6N9zaSAGJzjKRbFkTQ"};